import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { getHeaders } from '../utlis/security';
import { BASE_API_URL } from '../constants';

export const homepageApi = createApi({
  reducerPath: 'homepageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('homepageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchHomeData: builder.query({
      query: () => ({
        url : '/music/homepage',
        method: 'POST',
        body : {
          phone: "",
          platform: "miniapp",
          udid: "190740e5f0032702",
          user_id: "",
          version_code: 20,
          version_name: "1.2.9"
      }
      }), 
    }),
    fetchSeeAllData: builder.query({
      query: (options) => ({
        url : options.url,
        method: 'POST',
        body : {
            phone: "",
            platform: "miniapp",
            udid: "190740e5f0032702",
            version_code: 20,
            version_name: "1.2.9",
            user_id : getLocalStorageData(),
            category_id: options.category_id,
            ...options.body
          },
      }) 
    }),
    fetchDetailData: builder.query({
      query: (options) => ({
        url : options.url,
        method: 'POST',
        body : {
          phone: "",
          platform: "miniapp",
          udid: "190740e5f0032702",
          version_code: 20,
          user_id : getLocalStorageData(),
          version_name: "1.2.9",
          ...options.body
        }
      }), 
    }),
  }),
});

export const { useFetchHomeDataQuery , useFetchSeeAllDataQuery, useFetchDetailDataQuery, endpoints } = homepageApi;